export enum DocumentCollectionType {
    AD = 'ads',
    ANIMATION = 'animations',
    TEMPLATE = 'templates',
    ASSET = 'assets',
    PROJECT = 'projects',
    CLIENT = 'clients',
    CREATIVE = 'creatives',
    DEFAULT = 'children',
    COMMENTS = 'comments',
    TEARSHEET = 'tearsheets',
    BUNDLE = 'creativeBundles',
    BUNDLE_ELEMENT = 'creativeBundleElements',
    VIDEO_BUNDLE = 'videoBundles',
    VIDEO_BUNDLE_ELEMENT = 'videoBundleElements',
    USER = 'users',
    NONE = '',
}
